export default __webpack_public_path__ + "static/media/326.839d80ae.png";